import * as React from "react";
const SvgIcCardFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M23 21H1V3H23V21ZM4 8H20V12H4V8Z" fill="currentColor" /></svg>;
export default SvgIcCardFilled;